export default __webpack_public_path__ + "static/media/Powerline.256.c7d98f73.png";